import { IconButton } from "@mui/material";
import React from "react";
interface IActionButtonProps {
  onEdit: () => void;
  onDelete: () => void;
}

const ActionButtons: React.FC<IActionButtonProps> = ({ onEdit, onDelete }) => {
  return (
    <React.Fragment>
      <IconButton onClick={onEdit}>
        <span
          className="material-symbols-outlined  icon-button"
          color="secondary"
        >
          edit
        </span>
      </IconButton>
      <IconButton onClick={onDelete}>
        <span className="material-symbols-outlined icon-button">delete</span>
      </IconButton>
    </React.Fragment>
  );
};

export default ActionButtons;
